import { render, staticRenderFns } from "./protocol_detail.vue?vue&type=template&id=d2776524&scoped=true&"
import script from "./protocol_detail.vue?vue&type=script&lang=js&"
export * from "./protocol_detail.vue?vue&type=script&lang=js&"
import style0 from "./protocol_detail.vue?vue&type=style&index=0&id=d2776524&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2776524",
  null
  
)

export default component.exports